import { isYes } from '../../../../../../../components/loan_application/utils/helpers';
import { ApplicationFormValues } from '../../../../LoanDetailTypes';
import loanFormModel from '../../form_models/loanFormModel';
import { Rule } from '../../interfaces/Rule';

const { willingToProvideCommercialGuarantor } = loanFormModel.formField;

class IsWillingToProvideCommercialGuarantor implements Rule {
  public evaluate(application: Partial<ApplicationFormValues>): boolean {
    const isWillingToProvideCommercialGuarantorValue = isYes(
      application[willingToProvideCommercialGuarantor.name]
    );
    return isWillingToProvideCommercialGuarantorValue;
  }
}

export default new IsWillingToProvideCommercialGuarantor();
